/**
 * Branding constants for ChitraKalakar
 */

export const BRAND_NAME = "ChitraKalakar";
export const BRAND_TAGLINE = "Let's breathe art";
export const BRAND_DESCRIPTION = "A community of artisans where users and artists connect to create, commission, and celebrate beautiful artworks.";

export const USER_ROLES = {
  USER: "user",
  ARTIST: "artist",
  INSTITUTION: "institution",
  ADMIN: "admin",
};

export const PRICING = {
  ARTIST_ANNUAL_FEE_INR: 500,
  ARTIST_ANNUAL_FEE_USD: 5,
  ARTIST_COMMISSION_PERCENT: 10,
  ARTIST_COMMISSION_INITIAL_COUNT: 5,
  ARTIST_COMMISSION_PERCENT_ADDITIONAL: 15,
  USER_PLATFORM_FEE_PERCENT: 10,
  EXHIBITION_FEE_3DAYS_INR: 1000,
  EXHIBITION_FEE_3DAYS_USD: 10,
  EXHIBITION_ARTWORKS_LIMIT: 10,
};

export const ART_CATEGORIES = [
  "Acrylic Colors",
  "Watercolors",
  "Pencil & Pen Work",
  "Pastels",
  "Indian Ink",
  "Illustrations",
  "Visual Art",
  "Digital Art",
  "Mixed Media",
  "Sculpture",
  "Photography",
  "Printmaking",
];

export const NAVIGATION_LINKS = {
  HOME: "/",
  ARTISTS: "/artists",
  PAINTINGS: "/paintings",
  EXHIBITIONS: "/exhibitions",
  ABOUT: "/about",
  CONTACT: "/contact",
  DASHBOARD: "/dashboard",
  ADMIN: "/admin",
  PROFILE: "/profile",
  FAQ: "/faq",
  PRIVACY: "/privacy",
  TERMS: "/terms",
};
